"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackRouterDirection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
var StackRouterDirection;
(function (StackRouterDirection) {
    StackRouterDirection["None"] = "";
    StackRouterDirection["Left"] = "left";
    StackRouterDirection["Right"] = "right";
    StackRouterDirection["Up"] = "up";
    StackRouterDirection["Down"] = "down";
})(StackRouterDirection || (exports.StackRouterDirection = StackRouterDirection = {}));
function StackRouter({ shouldAnimate = () => true, basePath, }) {
    var _a, _b;
    const location = (0, react_router_dom_1.useLocation)();
    let navigationType = (0, react_router_dom_1.useNavigationType)();
    const isBasePath = location.pathname === basePath;
    if (navigationType === react_router_dom_1.NavigationType.Replace) {
        navigationType = react_router_dom_1.NavigationType.Push;
    }
    if (isBasePath) {
        navigationType = react_router_dom_1.NavigationType.Pop;
    }
    const outlet = (0, react_router_dom_1.useOutlet)();
    const direction = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.direction) || StackRouterDirection.Up;
    const shouldNotAnimateFromState = ((_b = location.state) === null || _b === void 0 ? void 0 : _b.shouldAnimate) === false;
    const className = `stack-${direction} stack-${navigationType.toLowerCase()}`;
    const duration = 300;
    const transitionKey = location.pathname.split('/')[1] || 'main-page';
    const enterDuration = shouldAnimate(location.pathname) &&
        !isBasePath &&
        !shouldNotAnimateFromState
        ? duration
        : 0;
    const exitDuration = shouldAnimate(location.pathname) && !isBasePath ? duration : 0;
    return ((0, jsx_runtime_1.jsx)("div", { className: `history-${navigationType.toLowerCase()}`, children: (0, jsx_runtime_1.jsx)(react_transition_group_1.SwitchTransition, { mode: "in-out", children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { addEndListener: (node, done) => {
                    node.addEventListener('transitionend', done, false);
                }, classNames: "stack", unmountOnExit: true, mountOnEnter: true, children: () => {
                    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "$enterDuration": enterDuration, "$exitDuration": exitDuration, children: outlet }));
                } }, transitionKey) }) }));
}
exports.default = StackRouter;
const Container = styled_components_1.default.div `
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;

  /* On push we need to animate in the new page and then hide the old one */

  .history-push &.stack-enter {
    position: absolute;
    top: 0;
    left: 0;

    z-index: 2;
  }

  &.stack-enter {
    &.stack-${StackRouterDirection.Up} {
      transform: translate(0, 100%);
    }

    &.stack-${StackRouterDirection.Down} {
      transform: translate(0, -100%);
    }

    &.stack-${StackRouterDirection.Left} {
      transform: translate(100%, 0);
    }

    &.stack-${StackRouterDirection.Right} {
      transform: translate(-100%, 0);
    }
  }

  .history-push &.stack-enter-active {
    transform: translate(0, 0);
    transition: transform ${({ $enterDuration }) => $enterDuration}ms linear;
    transition-delay: ${({ $enterDuration }) => $enterDuration === 0 ? 1 : 0}ms;
  }

  .history-pop &.stack-enter-active {
    transform: translate(0, 0);
    transition: transform ${({ $enterDuration }) => $enterDuration}ms linear;
    transition-delay: ${({ $enterDuration }) => $enterDuration === 0 ? 1 : 0}ms;
  }

  .history-push &.stack-enter-done {
    position: absolute;
    top: 0;
    left: 0;
  }

  /* On pop we need to show the new page under the old one, and then animate out the old one */

  .history-pop &.stack-exit {
    position: absolute;
    top: 0;
    left: 0;

    z-index: 2;

    transform: translate(0, 0);
  }

  .history-pop &.stack-exit-active {
    transition: transform ${({ $exitDuration }) => $exitDuration}ms linear;
    transition-delay: ${({ $exitDuration }) => ($exitDuration === 0 ? 1 : 0)}ms;
  }

  .history-push &.stack-exit-active {
    transition: transform ${({ $exitDuration }) => $exitDuration}ms linear;
    transition-delay: ${({ $exitDuration }) => ($exitDuration === 0 ? 1 : 0)}ms;

    z-index: -1;
  }

  &.stack-exit-active {
    &.stack-${StackRouterDirection.Up} {
      transform: translate(0, 100%);
    }

    &.stack-${StackRouterDirection.Down} {
      transform: translate(0, -100%);
    }

    &.stack-${StackRouterDirection.Left} {
      transform: translate(100%, 0);
    }

    &.stack-${StackRouterDirection.Right} {
      transform: translate(-100%, 0);
    }
  }

  .history-pop &.stack-exit-done {
    display: none;
  }
`;
